import axios from 'axios'

import {Tag} from '@pages/TagsPage/store'
import {API_URL} from './requests'

const LOOK_BASE_URL = `${API_URL}/tags`
const getLookIdUrl = (tagId: Tag['id']) => `${LOOK_BASE_URL}/${tagId}`

export function loadTags() {
  return axios.get(LOOK_BASE_URL)
}

export function createTag(data: Tag) {
  return axios.post(LOOK_BASE_URL, data)
}

export function updateTag(tagId: Tag['id'], data: Tag) {
  return axios.patch(getLookIdUrl(tagId), data)
}

export function deleteTag(tagId: Tag['id']) {
  return axios.delete(getLookIdUrl(tagId))
}
